import { TextField } from '@material-ui/core';
import React from 'react';

const InputField = ({
  type,
  label,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
}) => {
  return (
    <TextField
      type={type}
      variant="filled"
      label={label}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};

export default InputField;
